'use client';

import { useTranslations } from 'next-intl';
import { ComponentType, SVGProps } from 'react';
import { cn } from '@/shared/lib/cn';
import { Icon } from '@/shared/ui/icon';
import './styles.scss';

type Props = {
    value: string;
    title: string;
    icon?: ComponentType<SVGProps<SVGSVGElement>> | null;
    time?: number;
    isActive: boolean;
    tagColor?: 'delivery' | 'pickup';
    onClick: () => void;
    'data-testid'?: string;
};

export const SelectDeliveryBoxDeliveryOption = ({
    value,
    title,
    icon: IconComponent,
    time,
    isActive,
    tagColor = 'delivery',
    onClick,
    ...props
}: Props) => {
    const t = useTranslations();
    return (
        <button
            type="button"
            value={value}
            onClick={onClick}
            className={cn('select-delivery-box__option', isActive && 'select-delivery-box__option--active')}
            data-testid={props['data-testid']}
        >
            {IconComponent && (
                <span className="select-delivery-box__option-icon">
                    <IconComponent />
                </span>
            )}
            <span className="select-delivery-box__option-title">{title}</span>
            {Number.isFinite(time) && (time as number) > 0 && (
                <span
                    className={cn(
                        'select-delivery-box__option-time',
                        `select-delivery-box__option-time--${tagColor}`,
                    )}
                >
                    <Icon name="clock" />
                    {t('SELECT_DELIVERY_BOX.MINUTES_SHORT', { minutes: time as number })}
                </span>
            )}
        </button>
    );
};
